<template>
  <vs-sidebar
    default-index="1"
    :parent="parent"
    :hiddenBackground="$store.getters['IS_SIDEBAR_ACTIVE']"
    class="sidebarx"
    spacer
    v-model="$store.getters['IS_SIDEBAR_ACTIVE']"
    :click-not-close="$store.getters['IS_SIDEBAR_ACTIVE']"
  >
    <vs-sidebar-group title="Process Monitor" open>
      <vs-sidebar-item :to="'/Overview'" index="1" icon="cloud_queue">
        Overview
      </vs-sidebar-item>
      <vs-sidebar-item :to="'/Report'" index="2" icon="description">
        Report
      </vs-sidebar-item>
      <vs-sidebar-group title="Dashboard Monitor" open>
        <vs-sidebar-item
          :to="{ name: 'v-steel', params: { place: 'vsteel1' } }"
          index="3"
          icon="dashboard"
        >
          Maxsale
        </vs-sidebar-item>
        <vs-sidebar-item
          :to="{ name: 'v-steel', params: { place: 'vsteel2' } }"
          index="3"
          icon="dashboard"
        >
          วี-บิ้วท์ ลำลูกกา
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/v-steel/vsteel5'" index="3" icon="dashboard">
          ที-วัน รัตนาธิเบศร์
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/v-steel/vsteel4'" index="3" icon="dashboard">
          ที-วัน บ้านโป่ง
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/v-steel/vsteel3'" index="3" icon="dashboard">
          วี-สตีล อยุธยา
        </vs-sidebar-item>
      </vs-sidebar-group>
      <vs-sidebar-group title="Device Mangement">
        <vs-sidebar-item :to="'/sensor'" index="2.2" icon="settings_remote">
          Device
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/gateway'" index="2.3" icon="router">
          Gateway
        </vs-sidebar-item>
      </vs-sidebar-group>
    </vs-sidebar-group>

    <footer-sidebar slot="footer"></footer-sidebar>
  </vs-sidebar>
</template>

<script>
import FooterSidebar from "../FooterSidebar.vue";
export default {
  name: "BetagroSidebar",
  components: {
    FooterSidebar,
  },
  data() {
    return {};
  },
};
</script>

<style>
</style>